import { render, staticRenderFns } from "./EstimatesDetails.vue?vue&type=template&id=22314f91&scoped=true"
import script from "./EstimatesDetails.vue?vue&type=script&lang=js"
export * from "./EstimatesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22314f91",
  null
  
)

export default component.exports